import { createCommonjsModule } from '../../_virtual/_commonjsHelpers.js';
import reactJsxRuntime_production_min from './cjs/react-jsx-runtime.production.min.js';
import reactJsxRuntime_development from './cjs/react-jsx-runtime.development.js';

var jsxRuntime = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactJsxRuntime_production_min;
} else {
  module.exports = reactJsxRuntime_development;
}
});

export { jsxRuntime as default };
//# sourceMappingURL=jsx-runtime.js.map
